import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GeefUwInterieurEenTweedeLeven() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll();
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="24889" id="exclusieve-haarwerken-beauty" className="relative h-screen w-full overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/luxury_hotel_lounge_parallax.png)] bg-cover bg-center bg-fixed bg-no-repeat" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/50" />

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="max-w-4xl space-y-8">
          {}
          <h1 ref={titleRef} className={`font-serif text-5xl font-bold leading-tight tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl transition-all duration-1000 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>Jouw uitstraling, onze expertise.</h1>

          <p className="font-serif tracking-widest text-white/80 transition-all duration-1000 delay-150 ease-out opacity-100 translate-y-0 !text-4xl">-Since 2003-</p>

          {}
          <p ref={textRef} className={`mx-auto max-w-2xl font-sans text-lg font-medium text-white/90 sm:text-xl md:text-2xl transition-all duration-1000 delay-300 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            Vakmanschap en persoonlijke aandacht. Elke behandeling, een meesterwerk.
          </p>

          {}
          <div ref={ctaRef} className={`pt-4 transition-all duration-1000 delay-500 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Button asChild size="lg" className="bg-[var(--primary)] text-[var(--primary-foreground)] hover:bg-[var(--primary)]/90 hover:shadow-[0_0_20px_rgba(203,189,189,0.5)] border-none px-8 py-6 text-lg font-semibold tracking-wide transition-all duration-300">
              <Link to="/HomePage">
                Maak een Afspraak
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <Link to="#onze-expertise" aria-label="Scroll naar beneden">
          <ArrowDown className="h-8 w-8 text-white/80 hover:text-white transition-colors" />
        </Link>
      </div>
    </section>;
}